import React from "react";
import { C, radii, shadows, space } from "../../styles/tokens";

/**
 * Approved Brand Card (docs/BRAND_MANUAL.md, section 8)
 * White, radius 16, card shadow, no border.
 */
export function BrandCard({
  children,
  padding = space.lg, // 16px
  style = {},
  className = "",
  as: Component = "div",
  ...rest
}) {
  return (
    <Component
      className={className}
      style={{
        backgroundColor: C.surface,
        borderRadius: radii.card,
        boxShadow: shadows.card,
        border: "none",
        padding,
        boxSizing: "border-box",
        ...style,
      }}
      {...rest}
    >
      {children}
    </Component>
  );
}
